import React, { useCallback } from "react";
import { useRouter } from "next/router";
import HiringWhy from "../../components/Blc-sec/HiringWhy";
import PriceList from "../../components/Hiring/PriceList";
import PageHeader from "../..//components/Page-header";
import Breadcrumbs from "../../components/Breadcrumbs";
import Seo from "../../components/SEO";
import axios from "axios";
import Link from "next/link";
import AboutExperts from "../../components/About-Services/Services7/Experts";
import MinimalArea from "../../components/Minimal-area";
function Hiring({  servicesLink }) {

  const route = useRouter();

  const removeCharacters = (str) => {
    return str.replace(/[\/()]/g, "");
  };

  const updatedData = servicesLink.map(item => {
    const updatedSubServices = item.subServices.map(sub => {
      return {
        ...sub,
        title: removeCharacters(sub.title)
      };
    });
    return {
      ...item,
      subServices: updatedSubServices
    };
  });
  
  const sortServiceList = useCallback(() => {
    
    if (servicesLink?.length) {
      let sortedList = servicesLink.sort((a, b) => b.subServices.length - a.subServices.length);
      if (sortedList.length >= 10) {
        const itemToMove1 = sortedList.splice(4, 1)[0];
        sortedList.splice(9, 0, itemToMove1);
        const itemToMove2 = sortedList.splice(8, 1)[0];
        sortedList.splice(7, 0, itemToMove2);
      }
      return sortedList;
    }
    return [];
  }, [servicesLink]);

  const handlerLink = (title) => {
    route.push(`/hire-us/${title.toLowerCase().replace(/ /g, "-")}-developer`)
  }

  const list = [
    "We have problem-solving skills and a record of success. We have been in business for over 5+ years and have a strong reputation for providing quality software IT solutions. We are an IT consulting excellence in Information monetization technology.",
    "We have a team of IT consulting excellence professionals. Our team of software engineers, testers, and consultants has a wealth of experience in a variety of industries. We are one of the most trustworthy IT Companies among all IT companies.",
    "We are dedicated to offering an outstanding level of service to our customers. We are a provider of business IT software solutions for a wide range of industries, including healthcare, financial services, manufacturing, retail, data backup & and recovery.",
    "About Settings Infotech is an IT Services expertise and cybersecurity specialist. We are committed to providing our employees with a stimulating and rewarding work environment. We offer a competitive salary and benefits package, as well as opportunities for professional development and growth"
  ]
  
  return (
    <>
   <Seo
        key="Hire Developer"
        link="https://settingsinfotech.com/hire-us/"
        title="Hire Developer | Settings Infotech"
        description="Find the interesting career opportunities at Settings Infotech in a wide range of fields, including as all IT positions."
        Keywords="Requirement Analysis, Programming Development, Deployment & Maintenance, IT Services Expertise, Cybersecurity Specialists, Software Architecture, Data Backup and Recovery Services, Business IT Solutions, Settings Infotech About Us, IT Consulting Excellence, IT Solutions Provider, Problem-Solving Skills, Cutting-Edge Solutions, Trustworthy It Company, Global Reach MNC Company, Requirement Analysis, Wireframing & Designing, Programming Development, Deployment & Maintenance, Requirements gathering, Network Infrastructure, IT Roadmap, IT Resource Management, IT Outsourcing Services, IT Auditing, IT Lifecycle Management, IT Modernization, Software Integration, Cloud Computing, Digital Transformation, Business Intelligence, Technology Consulting, AI and Machine Learning, Software Consulting, About Settings Infotech"
      />
      <PageHeader
        subtitle="Let's View"
        title='Hire Us'  
        bgTitle='Hire Us'
        description="Become a part of our team and start on a journey where technology meets opportunity!"
      />
      <Breadcrumbs />
      <section className="pb-25">
        <section className='services home-services pt-15'>
          <div className='container'>
            <div className='row pt-15 sitemapTitle sitemapTitleBg' >
              Hire Our Developer
            </div>
          </div>
        </section>
        <section className='services home-services'>
          <div className='container'>
            <div className='row'>
              {sortServiceList()?.map((item, index) => {
                return (
                  <div
                    key={item?._id}
                    // className='col-lg-4 col-md-6 col-sm-12 col-12 col-12 text-left item-box pt-15 pb-15 right-to-lrft-item-box wow fadeInLeft'
                     className={`col-lg-4 col-md-6 col-sm-12 col-12 text-left item-box pt-15 pb-15 right-to-lrft-item-box wow fadeInLeft ${
    item?._id === 6 ? "bg-dark" : ""
  }`}
                    data-wow-delay='.1s'
                    // style={{
                    //   flex: "unset",
                    //   background: item?._id === 6 ? "#1a1e25" : "",
                    // }}
                  >
                    <div className="w-100">
                      <h2 className='custom-anchor'>
                        {item?.title}
                      </h2>
                    </div>
                    <ul className='smp-list'>
                      {
                        item?.subServices?.map((list) => {
                          return (
                            <>
                              <li key={list?.title} className='mt-0'>
                                <div className="custom-anchor pt-1 pb-1 pl-0" onClick={()=> handlerLink(list?.slug) }>
                                    Hire {list?.title} Developer
                                </div>
                              </li>
                            </>
                          )
                        })
                      }
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </section>   
      <AboutExperts />

      <MinimalArea
        imgSrc="/img/min-area.png"
        alt="whyus"
        contentList={list}
        firstTitle="why you should choose"
        secondTitle='Settings Infotech.'
        subTitle="Why choose us?"
        firstDescription="Here are some of the reasons why you should choose Setting Infotech"
        secondDescription="Settings Infotech is an ideal choice for you if you are seeking for a software firm that can help you reach your business goals. To learn more about our services, please contact us immediately."
        contentClassName="pl-4"
      />
    </>
  );
}

export default Hiring;

export async function getStaticProps() {
  let servicesLink = [];
  const response = await axios.get(`${process.env.LOCAL_API_URL}/services/getServiceMenu`);
  if (response.data.status === 200) {
    servicesLink = response.data.data
  }
  return {
    props: {
      servicesLink: servicesLink
    },
  };
}



